import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import './markdown.scss';

type TStyleType = 'none' | 'common' | 'post';

interface IMarkdownProps {
    children: string;
    className?: string;
    styleType?: TStyleType;
}

const Markdown: React.FC<IMarkdownProps> = ({ children, className = '', styleType = 'none' }) => {
    const styleTypeClass = styleTypeClasses[styleType];

    return (
        <ReactMarkdown
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            rehypePlugins={[rehypeRaw]}
            className={`${styleTypeClass} ${className}`}
            components={{
                script: () => null,
            }}
        >
            {children}
        </ReactMarkdown>
    );
};

const styleTypeClasses: Record<TStyleType, string> = {
    common: 'markdown-common',
    post: 'markdown-post',
    none: '',
};

export default Markdown;
